import { defineRoute, type RouterConfig } from '@crown/router';
import { docEntries } from './content/content-manifest';
import { ArchitectureHubPage } from './pages/architecture';
import { docPage } from './pages/doc-page';
import { DslPlaygroundPage } from './pages/dsl-playground';
import { HomePage } from './pages/home';

const overviewRoute = defineRoute({
  path: '',
  component: HomePage,
  preload: true,
  meta: { icon: 'home' },
});

const architectureHubRoute = defineRoute({
  path: 'architecture',
  component: ArchitectureHubPage,
  preload: true,
  meta: { icon: 'layout-grid' },
});

const dslPlaygroundRoute = defineRoute({
  path: 'dsl-playground',
  component: DslPlaygroundPage,
  preload: true,
  meta: { icon: 'terminal' },
});

const docRoutes = docEntries.map((entry) =>
  defineRoute({
    path: entry.routePath,
    component: docPage(entry.routePath),
    preload:
      entry.routePath.includes('architecture/ubuntu') ||
      entry.routePath.includes('architecture/multi-node'),
    meta: { icon: 'file-text' },
  }),
);

export const routes = [
  overviewRoute,
  architectureHubRoute,
  dslPlaygroundRoute,
  ...docRoutes,
] as const;

type AnyRoute = import('@crown/router').RouteConfig<unknown>;
function widenRoutes<R extends readonly unknown[]>(routeList: R) {
  return routeList as unknown as readonly AnyRoute[];
}

export const routerConfig: RouterConfig<readonly AnyRoute[]> = {
  base: '/',
  defaultRoute: '',
  notFoundRoute: undefined,
  enablePrefetch: true,
  prefetchDelay: 150,
  routes: widenRoutes(routes),
};
